import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import Gleap from 'gleap'

interface Props {
  articleId?: string
  block?: boolean
  label?: string
  externalLink?: string
}
export const HelpButton = ({
  articleId,
  block = false,
  label,
  externalLink,
}: Props) => {
  return (
    <Button
      variant="outlined"
      color="primary"
      block={block}
      icon={<QuestionCircleOutlined />}
      onClick={
        externalLink != undefined
          ? undefined
          : () => Gleap.openHelpCenterArticle(articleId ?? '', false)
      }
      href={externalLink}
      target={externalLink != undefined ? 'blank' : undefined}
    >
      {label ? label : 'Help'}
    </Button>
  )
}
